module.exports = __webpack_public_path__ + "img/cartoon-network.aa631861.svg";